module.exports = __webpack_public_path__ + "img/解决方案_BMS_白.3ad7a0c1.svg";